'use strict';

function isRefObject(ref) {
    return (ref &&
        typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

exports.isRefObject = isRefObject;
//# sourceMappingURL=is-ref-object.cjs.map
